export default __webpack_public_path__ + "static/media/key-hole-unlocked.4661875c.svg";